import React from 'react'

function AdminProfile() {
  return (
    <div>AdminProfile</div>
  )
}

export default AdminProfile